module.exports = __webpack_public_path__ + "static/media/logo-white.ab15f194.png";